import apiGetRequest from './base/api-get-request'
import { screenshotHeaders } from 'src/main_app/utils/screenshot-access'

// Tenant comes from the screenshot token / login, not from the request
const getNineCustomerTheMostAlertScreenshot = () =>
    apiGetRequest(`/alerts/nine-customer-the-most-for-screenshot`)({ headers: screenshotHeaders() })

export default getNineCustomerTheMostAlertScreenshot
